import Image from "next/image";
import { MatchupDisplayProps } from "@/types/scoreBoard";
import styles from "./matchupDisplay.module.scss";

const MatchupDisplay = ({
  homeTeamImage,
  awayTeamImage,
  homeTeamColor,
  awayTeamColor,
  homeTeam,
  awayTeam,
  "data-testid": dataTestId,
}: MatchupDisplayProps) => {
  return (
    <div className={styles.matchupContainer}>
      <div
        className={styles.desktopContainer}
        data-testid={dataTestId ?? "matchup-display"}
      >
        <div
          className={styles.awayColor}
          style={{ backgroundColor: awayTeamColor }}
        />
        <div
          className={styles.homeColor}
          style={{ backgroundColor: homeTeamColor }}
        />
        <Image
          src={awayTeamImage}
          width={100}
          height={100}
          alt={`${awayTeam} Logo`}
          className={styles.awayTeamLogo}
        />
        <Image
          src={homeTeamImage}
          width={100}
          height={100}
          alt={`${homeTeam} Logo`}
          className={styles.homeTeamLogo}
        />
      </div>
    </div>
  );
};

export default MatchupDisplay;
